import { useMutation } from '@tanstack/react-query';
import { getFileDownloadUrl } from '../api/filesApi';

export function useFileDownload() {
  return useMutation({
    mutationFn: (fileId: string) => getFileDownloadUrl(fileId),
    onSuccess: data => {
      const link = document.createElement('a');
      link.href = data.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.click();
    },
  });
}
